import { countryConfig } from '@/app/utils/countryConfig';

export const getMaxAmountBasedTipOption = () => {
  return countryConfig.amountBasedTipOptions[countryConfig.amountBasedTipOptions.length - 1].to;
};

export const getDefaultAmountBasedValue = (amount: number) => {
  const group = countryConfig.amountBasedTipOptions.find((option) => {
    return amount >= option.from && amount <= option.to;
  });

  if (!group) {
    return undefined;
  }

  return group.default;
};
